<template>
  <de-layout-content>
    <div class="pad-b20">
      <div class="bl_title">新增接入</div>
      <from-dom componentsType="add" />
    </div>
  </de-layout-content>
</template>
<script>
import FromDom from "./fromDom.vue";
export default {
  components: {
    FromDom,
  },
  data() {
    return {};
  },
};
</script>
<style scoped lang='less'>
.bl_title {
  font-size: 16px;
  font-weight: bold;
  width: 100%;
  display: inline-block;
  margin-bottom: 20px;
}
</style>
